import { cn } from '@/lib/utils'
import type { ExpirationStatus } from '@/modules/common/expiration-status'
import { useTranslate } from '@ur-solutions/react-hooks'

const statusClassNames: Record<ExpirationStatus, string> = {
  expired: 'border-rose-300 bg-rose-100 text-rose-900',
  expiring_soon: 'border-amber-300 bg-amber-100 text-amber-900',
  valid: 'border-emerald-300 bg-emerald-100 text-emerald-900',
  missing: 'border-stone-300 bg-stone-100 text-stone-700',
}

/** Translation keys for a status, also used for the filter's option labels. */
export function useExpirationStatusLabels(): Record<ExpirationStatus, string> {
  return useTranslate({
    expired: 'vehicles.expiration-status.expired',
    expiring_soon: 'vehicles.expiration-status.expiring-soon',
    valid: 'vehicles.expiration-status.valid',
    missing: 'vehicles.expiration-status.missing',
  })
}

interface Props {
  status: ExpirationStatus
  className?: string
}

export const ExpirationStatusBadge: React.FC<Props> = ({
  status,
  className,
}) => {
  const labels = useExpirationStatusLabels()

  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap',
        statusClassNames[status],
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {labels[status]}
    </span>
  )
}
